import { Document, Page, Text, View } from "@react-pdf/renderer";
import * as React from "react";
import { OrderCategory, TApiOrderDetails } from "../../../api/endpoints/Order";
import { TOrderProduct } from "../../../api/endpoints/OrderProduct";
import { AdditionalChargesFootnote, LimitCapacityFootnoteLegacy, ResearchAndSmallBusinessFootnote } from "../../Footnotes";
import OrderCostSummaryPdf from "../OrderCostSummaryPdf";
import OrderDetailsPdf from "../OrderDetailsPdf";
import { OrderPdfProps } from "../types";
import ProductDetails from "./ProductDetails";

interface IProps extends OrderPdfProps {
  order: TApiOrderDetails<OrderCategory.EU_CUTOUT>;
  product?: TOrderProduct<OrderCategory.EU_CUTOUT>;
}

const EuCutoutOrderPDF = (props: IProps) => {
  const { user, order, currentCostingVersion, styles, product } = props;

  return (
    <Document>
      <Page style={styles.pageStyles}>
        <OrderDetailsPdf {...props} />

        {
          product &&
          <ProductDetails product={product} {...props} />
        }

        <OrderCostSummaryPdf
          user={user}
          order={order}
          currentCostingVersion={currentCostingVersion}
          styles={styles}
          annualTotalCostFootnoteRef="**"
        />

        <View style={styles.disclaimers}>
          <View style={[styles.disclaimer, styles.flexRow]}>
            <View>
              <Text>
                *
              </Text>
            </View>

            <View style={styles.disclaimerContent}>
              <Text style={styles.listItem}>
                <AdditionalChargesFootnote pdf />
              </Text>

              <Text style={styles.listItem}>
                <ResearchAndSmallBusinessFootnote pdf />
              </Text>

              <Text style={styles.listItem}>
                <LimitCapacityFootnoteLegacy pdf />
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default EuCutoutOrderPDF;
